import React, { Component } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, useLocation } from "react-router-dom";
import Loader from "../../components/loader";
import Cookies from "universal-cookie";
import NoIndexWrap from "../NoIndexWrap/NoIndexWrap";

const cookie = new Cookies();

function PremiumRoute(props) {
  const user_info = useSelector((state) => state.my_account.user_info);

  const router = useLocation();
  const isAuth = cookie.get("user_token");

  const isPremiumOrPro =
    user_info?.role === "Admin" ||
    (user_info?.auth_token && (user_info?.subscription_type?.includes("PRO") || user_info?.subscription_type?.includes("PREMIUM")));

  if (isAuth && !user_info?.id) {
    return <Loader />;
  }

  return (
    <>
      {isPremiumOrPro ? (
        <NoIndexWrap>
          <Route {...props} render={(props) => <Component {...props} />} />
        </NoIndexWrap>
      ) : (
        <>
          {!user_info?.auth_token ? (
            <Redirect
              to={{
                pathname: "/login",
              }}
            />
          ) : (
            <Redirect
              to={{
                pathname: "/resources",
                state: {
                  from: router?.pathname,
                },
              }}
            />
          )}
        </>
      )}
    </>
  );
}

export default PremiumRoute;
